/* =====================================================================
   KIT NULANOVA · lógica
   1) Bundle (hasta 5 opciones, regalos reales y protección de envío)
   2) Barra de oferta con cuenta atrás
   3) Bolitas en carruseles (Multicolumna y Nulanova · Carrusel)
   4) Carrusel de vídeos: reproduce solo los visibles
   5) Antes / después
   6) Fecha estimada de entrega
   7) Carrito: contador de artículos y retirada de regalos sin producto
   8) Botón «volver arriba»
   Todo se inicializa al cargar y de nuevo cuando el editor redibuja una sección.
   ===================================================================== */
(function () {
  'use strict';

  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CLAVE_PROT_OFF = 'nn_prot_off';
  var bundles = [];

  function leerSesion(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function guardarSesion(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function postJSON(ruta, datos) {
    return fetch(raiz + ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }

  /* ---------------- 1) BUNDLE ---------------- */
  function initBundle(root) {
    if (!root || root.dataset.ready) return;
    var dataEl = root.querySelector('.nnb-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.ready = '1';

    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });
    var opById = {};
    (data.opciones || []).forEach(function (o) { opById[o.n] = o; });
    var cards = root.querySelectorAll('.nnb-card');
    var errorEl = root.querySelector('.nnb-error');
    if (!cards.length) return;

    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    // Al cambiar de color, la foto grande de la galería pasa a la de ese color
    function mostrarFoto(mediaId) {
      if (!mediaId) return;
      var item = document.querySelector('media-gallery [data-media-id$="-' + mediaId + '"]');
      var galeria = item && item.closest('media-gallery');
      if (galeria && typeof galeria.setActiveMedia === 'function') galeria.setActiveMedia(item.dataset.mediaId, false);
    }
    function activeCard() { return root.querySelector('.nnb-card.is-active') || cards[0]; }

    function productForms() {
      return Array.prototype.filter.call(document.querySelectorAll('product-form form[action*="/cart/add"]'), function (f) {
        var idInput = f.querySelector('[name="id"]');
        return idInput && byId[parseInt(idInput.value, 10)];
      });
    }

    function syncForm() {
      var row = activeCard().querySelector('.nnb-row');
      if (!row) return;
      productForms().forEach(function (f) { f.querySelector('[name="id"]').value = row.dataset.variant; });
    }

    function updateRow(row) {
      var opts = Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
      var v = findVariant(opts);
      if (!v) {
        v = data.variants.filter(function (x) { return x.options[0] === opts[0]; })[0] || data.variants[0];
        row.querySelectorAll('select').forEach(function (s, i) { s.value = v.options[i]; });
      }
      row.dataset.variant = v.id;
            mostrarFoto(v.media);
      var img = row.querySelector('.nnb-thumb');
      if (img && v.image) img.src = v.image;
      syncForm();
    }

    function buildRows(card) {
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var wrap = card.querySelector('.nnb-rows');
      if (wrap.children.length) return;
      var start = byId[data.initial] || data.variants[0];
      var conSelects = data.showSelects && !data.defaultOnly;
      for (var n = 0; n < qty; n++) {
        var row = document.createElement('div');
        row.className = 'nnb-row';
        row.dataset.variant = start.id;
        if (qty > 1) {
          var num = document.createElement('span');
          num.className = 'nnb-row-num';
          num.textContent = '#' + (n + 1);
          row.appendChild(num);
        }
        var img = document.createElement('img');
        img.className = 'nnb-thumb';
        img.alt = '';
        img.width = 42; img.height = 42;
        if (start.image) img.src = start.image;
        row.appendChild(img);
        if (!conSelects) {
          var tit = document.createElement('span');
          tit.className = 'nnb-row-tit';
          tit.textContent = data.title;
          row.appendChild(tit);
        } else {
          data.options.forEach(function (opt, idx) {
            var sel = document.createElement('select');
            sel.setAttribute('aria-label', opt.name);
            opt.values.forEach(function (val) {
              var o = document.createElement('option');
              o.value = val; o.textContent = val;
              if (start.options[idx] === val) o.selected = true;
              sel.appendChild(o);
            });
            sel.addEventListener('change', function () { updateRow(this.closest('.nnb-row')); });
            sel.addEventListener('click', function (e) { e.stopPropagation(); });
            row.appendChild(sel);
          });
        }
        wrap.appendChild(row);
      }
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      buildRows(card);
      syncForm();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        if (!card.classList.contains('is-active')) selectCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('select')) { e.preventDefault(); selectCard(card); }
      });
    });

    selectCard(activeCard());

    bundles.push({
      root: root,
      selectByBlock: function (blockId) {
        var c = root.querySelector('.nnb-card[data-block="' + blockId + '"]');
        if (c) selectCard(c);
      },
      owns: function (variantId) { return !!byId[variantId] && document.body.contains(root); },
      items: function () {
        var counts = {}, order = [];
        activeCard().querySelectorAll('.nnb-row').forEach(function (r) {
          var id = r.dataset.variant;
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id]++;
        });
        return order.map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      },
      gifts: function () {
        var o = opById[parseInt(activeCard().dataset.op, 10)];
        return o && o.gifts ? o.gifts : [];
      },
            // Unidades mínimas del producto para conservar este regalo (la opción más pequeña que lo incluye)
      giftMin: function (gid) {
        var m = 0;
        (data.opciones || []).forEach(function (o) {
          if (o.gifts && o.gifts.indexOf(gid) !== -1 && (!m || o.qty < m)) m = o.qty;
        });
        return m || 1;
      },
      prot: function () { return data.protAuto && data.prot ? data.prot : null; },
      error: function (msg) {
        if (!errorEl) return;
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }
    });
  }

  /* Un único escuchador para todos los bundles de la página */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('product-form form[action*="/cart/add"]')) return;
    var idInput = f.querySelector('[name="id"]');
    var vid = idInput ? parseInt(idInput.value, 10) : 0;
    var bundle = null;
    for (var i = 0; i < bundles.length; i++) { if (bundles[i].owns(vid)) { bundle = bundles[i]; break; } }
    if (!bundle) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var botones = Array.prototype.slice.call(f.querySelectorAll('[type="submit"]'));
    if (f.id) {
      document.querySelectorAll('button[form]').forEach(function (b) { if (b.getAttribute('form') === f.id) botones.push(b); });
    }
    botones.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.classList.add('loading'); });
    bundle.error('');

    var drawer = document.querySelector('cart-drawer');
    var principales = bundle.items();

    fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var enCarrito = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties._nn_regalo) enCarrito['g' + it.variant_id] = true;
          enCarrito['v' + it.variant_id] = true;
        });
        var extras = [];
        bundle.gifts().forEach(function (gid) {
          if (!enCarrito['g' + gid]) extras.push({ id: gid, quantity: 1, properties: { _nn_regalo: String(bundle.giftMin(gid)) } });
        });
        var prot = bundle.prot();
        if (prot && !enCarrito['v' + prot] && leerSesion(CLAVE_PROT_OFF) !== '1') extras.push({ id: prot, quantity: 1 });

        var cuerpo = function (items) { return { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }; };
        return postJSON('cart/add.js', cuerpo(principales.concat(extras))).then(function (res) {
          // Si falla un regalo o la protección (sin stock, borrado…), se añade al menos el producto.
          if (!res.ok && extras.length) return postJSON('cart/add.js', cuerpo(principales));
          return res;
        });
      })
      .then(function (res) {
        if (!res.ok) { bundle.error(res.d.description || res.d.message || 'No se pudo añadir al carrito.'); return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.d.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.d);
        } else {
          window.location.href = raiz + 'cart';
        }
      })
      .catch(function () { window.location.href = raiz + 'cart'; })
      .then(function () { botones.forEach(function (b) { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); }); });
  }, true);

  /* En el editor, al pulsar un bloque «Nulanova · Opción» se marca esa opción */
  document.addEventListener('shopify:block:select', function (e) {
    var id = e.detail && e.detail.blockId;
    if (!id) return;
    bundles.forEach(function (b) { b.selectByBlock(id); });
  });

  /* ---------------- 2) BARRA DE OFERTA ---------------- */
  function initOfferBar(bar) {
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var txt = bar.querySelector('.nnb-bar-txt'), reloj = bar.querySelector('.nnb-bar-reloj');
    if (bar.dataset.contador === 'false') return;
    var eh = bar.querySelector('.nnb-bar-h'), em = bar.querySelector('.nnb-bar-m'), es = bar.querySelector('.nnb-bar-s');
    var duracion = (parseInt(bar.dataset.min, 10) || 120) * 60000;
    var clave = 'nn_oferta_inicio';
    var inicio = parseInt(leerSesion(clave), 10);
    if (!inicio || isNaN(inicio)) {
      inicio = Date.now();
      guardarSesion(clave, String(inicio));
    }
    var fin = inicio + duracion, timer = null;
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.floor((fin - Date.now()) / 1000);
      if (s <= 0) {
        txt.textContent = bar.dataset.fin;
        reloj.hidden = true;
        if (timer) clearInterval(timer);
        return false;
      }
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      eh.textContent = dos(h); em.textContent = dos(m); es.textContent = dos(s);
      txt.textContent = bar.dataset.txt;
      reloj.hidden = false;
      return true;
    }
    if (tick()) timer = setInterval(tick, 1000);
  }

  /* ---------------- 3) BOLITAS DE CARRUSEL ---------------- */
  function crearBolitas(list, despuesDe, soloMovil) {
    var items = Array.prototype.filter.call(list.children, function (li) { return li.getClientRects().length; });
    if (items.length < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'nnb-dots' + (soloMovil ? ' nnb-dots--movil' : '');
    items.forEach(function (item, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
      d.addEventListener('click', function () { list.scrollTo({ left: item.offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); });
      wrap.appendChild(d);
    });
    despuesDe.parentNode.insertBefore(wrap, despuesDe.nextSibling);
    function update() {
      var pos = list.scrollLeft + items[0].offsetLeft, best = 0, dist = Infinity;
      items.forEach(function (item, i) { var dd = Math.abs(item.offsetLeft - pos); if (dd < dist) { dist = dd; best = i; } });
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 5) best = items.length - 1;
      Array.prototype.forEach.call(wrap.children, function (d, i) { d.classList.toggle('is-active', i === best); });
      wrap.hidden = list.scrollWidth <= list.clientWidth + 5;
    }
    list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initDots(sc) {
    if (!sc || sc.dataset.dots) return;
    var list = sc.querySelector('.slider');
    if (!list) return;
    sc.dataset.dots = '1';
    var buttons = sc.querySelector('.slider-buttons');
    crearBolitas(list, buttons || list, true);
  }

  /* ---------------- 4) CARRUSEL DE VÍDEOS ---------------- */
  function initMedia(sec) {
    if (!sec || sec.dataset.ready) return;
    sec.dataset.ready = '1';
    var list = sec.querySelector('.nn-media-list');
    if (!list) return;
    if (sec.dataset.dots === 'true') crearBolitas(list, list, false);
    var videos = sec.querySelectorAll('video');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) { videos.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio > 0.5) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: [0, 0.5, 1] });
    videos.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------------- 5) ANTES / DESPUÉS ---------------- */
  function initAntesDespues(el) {
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    var rango = el.querySelector('input[type="range"]');
    if (!rango) return;
    function pintar() { el.style.setProperty('--nn-ba-pos', rango.value + '%'); }
    rango.addEventListener('input', pintar);
    pintar();
  }

  /* ---------------- 6) FECHA DE ENTREGA ---------------- */
  function sumarDias(fecha, dias, laborables) {
    var d = new Date(fecha.getTime());
    if (!laborables) { d.setDate(d.getDate() + dias); return d; }
    var n = 0;
    while (n < dias) {
      d.setDate(d.getDate() + 1);
      var dia = d.getDay();
      if (dia !== 0 && dia !== 6) n++;
    }
    return d;
  }
  function initEntrega(el) {
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    var min = parseInt(el.dataset.min, 10) || 1;
    var max = Math.max(parseInt(el.dataset.max, 10) || min, min);
    var lab = el.dataset.laborables === 'true';
    var hoy = new Date();
    var lang = document.documentElement.lang || 'es';
    var fmt;
    try { fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { fmt = null; }
    function texto(d) { return fmt ? fmt.format(d).replace(/\./g, '') : d.toLocaleDateString(); }
    var esc = function (t) { var s = document.createElement('span'); s.textContent = t; return s.innerHTML; };
    var html = esc(el.dataset.texto || '')
      .replace('[desde]', '<b>' + esc(texto(sumarDias(hoy, min, lab))) + '</b>')
      .replace('[hasta]', '<b>' + esc(texto(sumarDias(hoy, max, lab))) + '</b>');
    el.querySelector('.nn-entrega-txt').innerHTML = html;
  }

  /* ---------------- 7) CARRITO ---------------- */
  var limpiando = false;
  function revisarCarrito() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var estado = drawer.querySelector('[data-nn-cart-state]');
    if (!estado) return;

    // Contador de artículos junto al título
    var cont = drawer.querySelector('[data-nn-cart-count]');
    if (cont) {
      var n = parseInt(estado.dataset.count, 10) || 0;
      cont.textContent = '• ' + n + ' ' + (n === 1 ? cont.dataset.uno : cont.dataset.varios);
      cont.hidden = n === 0;
    }

    // Regalos o protección sin producto principal: se retiran
    var huerfanos = (estado.dataset.huerfanos || '').split(',').filter(Boolean);
    if (!huerfanos.length || limpiando) return;
    limpiando = true;
    var updates = {};
    huerfanos.forEach(function (k) { updates[k] = 0; });
    postJSON('cart/update.js', { updates: updates, sections: 'cart-drawer,cart-icon-bubble' })
      .then(function (res) {
        if (!res.ok || !res.d.sections) { window.location.reload(); return; }
        var lector = new DOMParser();
        var nuevo = lector.parseFromString(res.d.sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        var actual = drawer.querySelector('.drawer__inner');
        if (nuevo && actual) {
          actual.innerHTML = nuevo.innerHTML;
          if (res.d.item_count === 0) drawer.classList.add('is-empty');
        }
        var burbujaNueva = lector.parseFromString(res.d.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        var burbuja = document.getElementById('cart-icon-bubble');
        if (burbujaNueva && burbuja) burbuja.innerHTML = burbujaNueva.innerHTML;
      })
      .catch(function () {})
      .then(function () { limpiando = false; });
  }

  var temporizadorCarrito = null;
  function vigilarCarrito() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.nnWatch) return;
    drawer.dataset.nnWatch = '1';
    new MutationObserver(function () {
      clearTimeout(temporizadorCarrito);
      temporizadorCarrito = setTimeout(revisarCarrito, 150);
    }).observe(drawer, { childList: true, subtree: true });
    revisarCarrito();
  }

  // Si el cliente quita la protección, no se vuelve a añadir sola en esta visita.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'cg-prot-toggle') guardarSesion(CLAVE_PROT_OFF, e.target.checked ? null : '1');
  }, true);

  /* ---------------- 8) VOLVER ARRIBA ---------------- */
  function initSubir(btn) {
    if (!btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.hidden = false;
    function update() { btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.2); }
    window.addEventListener('scroll', update, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    update();
  }

  /* ---------------- Arranque ---------------- */
  function initAll() {
    bundles = bundles.filter(function (b) { return document.body.contains(b.root); });
    document.querySelectorAll('[data-nn-bundle]').forEach(initBundle);
    document.querySelectorAll('[data-nn-offer-bar]').forEach(initOfferBar);
    document.querySelectorAll('.multicolumn slider-component').forEach(initDots);
    document.querySelectorAll('[data-nn-media]').forEach(initMedia);
    document.querySelectorAll('[data-nn-ba]').forEach(initAntesDespues);
    document.querySelectorAll('[data-nn-entrega]').forEach(initEntrega);
    document.querySelectorAll('[data-nn-top]').forEach(initSubir);
    vigilarCarrito();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 50); });
})();
